import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChiSoChiTietComponent } from '../../views/giam-sat/chi-so-cong-to-kh/chi-tiet/chisocongtokh-chitiet.component';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { HuongDanSuDungComponent } from '../huong-dan-su-dung/huongdansudung.component';
import { FixedheaderDirective, NumberOnlyDirective, ValidEmailDirective, ValidPhoneDirective, ComparePassWordDirective, SelectDefautDirective, ValidUsernameDirective, IsRequiredDirective, IntOnlyDirective, InputTrimDirective, NoSpaceDirective, TuTiDirective, FloatNumberDirective } from '../../directives';
import { TSVHChiTietComponent } from '../../views/giam-sat/thong-so-van-hanh/chi-tiet/thongsovanhanh-chitiet.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TSPTChiTietComponent } from '../../views/giam-sat/thong-so-phu-tai/chi-tiet/thongsophutai-chitiet.component';
import { ThongTinKHComponent } from 'app/views/nhap-thong-tin-kh/khach-hang-treo-thao/thong-tin-kh/thongtintkh.component';
import { CayThuMucComponent } from 'app/share/cay-thu-muc/caythumuc.component';
import { CayThuMucNewComponent } from 'app/share/cay-thu-muc-new/caythumuc.component';


import { ConfirmationService } from 'primeng/api';
import {PopchitietsukiencongtoComponent} from '../../views/canhbao/popchitietsukiencongto/popchitietsukiencongto.component'
import { ThongTinDCUComponent } from '../../views/nhap-thong-tin-kh/khach-hang-treo-thao/thong-tin-dcu/thongtindcu.component';
import { ThongTinCtoComponent } from '../../views/nhap-thong-tin-kh/khach-hang-treo-thao/thong-tin-cto/thongtincto.component';
import { MonthpickerComponent } from '../month-picker/monthpicker/monthpicker.component';
import { nearer } from 'q';
import { DocTucThoiComponent } from '../doc-tuc-thoi/doctucthoi.component';
import { ValidEmaiOrNulllDirective } from '../../directives/common/valid-email-allow-null.directive';
import { ValidPhoneAllowNullDirective } from '../../directives/common/valid-phone-allow-null.directive';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { ValidEmailCCDirective } from '../../directives/common/valid-emailcc.directive';
import { ValidPhoneCCDirective } from '../../directives/common/valid-phonecc.directive';
import { ExtracaythumucComponent } from '../extracaythumuc/extracaythumuc.component';
import { jqxModule } from './jqx.module';
import { MultidropdownComponent } from '../multidropdown/multidropdown.component';
import { NgxPrintModule } from 'ngx-print';
//import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    ProgressBarModule,
    MessageModule,
    MessagesModule,
    RadioButtonModule,
    TreeModule,
    TreeTableModule,
    jqxModule,
    NgxPrintModule
    //AngularMultiSelectModule
  ],
  declarations: [
    DocTucThoiComponent,
    ChiSoChiTietComponent,
    TSVHChiTietComponent,
    HuongDanSuDungComponent,
    CayThuMucNewComponent,
    TSPTChiTietComponent,
    ThongTinKHComponent,
    CayThuMucComponent,
    PopchitietsukiencongtoComponent,
    ThongTinDCUComponent,
    ThongTinCtoComponent,
    IsRequiredDirective,
    ValidEmailDirective,
    ValidPhoneDirective,
    ComparePassWordDirective,
    SelectDefautDirective,
    ValidUsernameDirective,
    FixedheaderDirective,
    NumberOnlyDirective,
    IntOnlyDirective,
    FloatNumberDirective,
    InputTrimDirective,
    MonthpickerComponent,
    NoSpaceDirective,
    TuTiDirective,
    ValidEmaiOrNulllDirective,
    ValidPhoneAllowNullDirective,
    ValidEmailCCDirective,
    ValidPhoneCCDirective,
    ExtracaythumucComponent,
    MultidropdownComponent,
  ],
  exports: [
    DocTucThoiComponent,
    ChiSoChiTietComponent,
    TSVHChiTietComponent,
    HuongDanSuDungComponent,
    CayThuMucNewComponent,
    TSPTChiTietComponent,
    ThongTinKHComponent,
    CayThuMucComponent,
    PopchitietsukiencongtoComponent,
    ThongTinDCUComponent,
    ThongTinCtoComponent,
    IsRequiredDirective,
    ValidEmailDirective,
    ValidPhoneDirective,
    ComparePassWordDirective,
    FixedheaderDirective,
    SelectDefautDirective,
    ValidUsernameDirective,
    NumberOnlyDirective,
    IntOnlyDirective,
    FloatNumberDirective,
    InputTrimDirective,
       MonthpickerComponent,
    NoSpaceDirective,
    TuTiDirective,
    ValidEmaiOrNulllDirective,
    ValidPhoneAllowNullDirective,
    ValidEmailCCDirective,
    ValidPhoneCCDirective,
    ExtracaythumucComponent,
    MultidropdownComponent,
    jqxModule
  ],
  providers: [
    ConfirmationService
  ]
})
export class ShareModule { }



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/modules/share.module.ts